module.exports = __webpack_public_path__ + "img/car-electric-second.cc7e8c87.jpg";